const GOOGLE_MAPS_JS_API_KEY = 'AIzaSyBW05AYXTf9RexOFTikTR2sCxlEOqYxxUg';

export { GOOGLE_MAPS_JS_API_KEY };